(function () {
  var syncing = false;
  var syncTimer = null;
  var observerTimer = null;

  function getBars() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-promo-gift-bar]'));
  }

  function getActiveBar() {
    var bars = getBars();
    return bars.find(function (bar) {
      return bar.dataset.promoEnabled !== 'false' && bar.querySelector('[data-promo-tier]');
    }) || bars[0] || null;
  }

  function formatMoney(cents, bar) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, bar.dataset.moneyFormat) + (bar.dataset.currencyCode || '');
    }

    return (cents / 100).toLocaleString(document.documentElement.lang || 'pt-BR', {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL'
    });
  }

  function replaceTokens(text, values) {
    return Object.keys(values).reduce(function (result, key) {
      return result.split('__' + key + '__').join(values[key]);
    }, text || '');
  }

  function renderBar(bar) {
    var tiers = Array.prototype.slice.call(bar.querySelectorAll('[data-promo-tier]'));
    if (bar.dataset.promoEnabled === 'false' || tiers.length === 0) {
      bar.hidden = true;
      return;
    }

    bar.hidden = false;
    tiers.sort(function (a, b) {
      return Number(a.dataset.tierThreshold) - Number(b.dataset.tierThreshold);
    });

    var total = Number(bar.dataset.qualifyingTotal) || 0;
    var earned = tiers.filter(function (tier) {
      return tier.dataset.tierEarned === 'true';
    });
    var upcoming = tiers.filter(function (tier) {
      return tier.dataset.tierEarned !== 'true';
    });
    var visible = upcoming.length ? upcoming.slice(0, 2) : earned.slice(-2);

    tiers.forEach(function (tier) {
      tier.hidden = visible.indexOf(tier) === -1;
      tier.classList.toggle('promo-gift-bar__tier--earned', tier.dataset.tierEarned === 'true');
    });

    var message = bar.querySelector('[data-promo-message]');
    var progress = bar.querySelector('[data-promo-progress]');
    var next = upcoming[0];

    if (!next) {
      message.textContent = bar.dataset.textAll;
      progress.style.width = '100%';
      return;
    }

    var nextThreshold = Number(next.dataset.tierThreshold);
    var previousThreshold = earned.length ? Number(earned[earned.length - 1].dataset.tierThreshold) : 0;
    var segmentSize = Math.max(nextThreshold - previousThreshold, 1);
    var progressPercent = Math.max(0, Math.min(100, ((total - previousThreshold) / segmentSize) * 100));
    var remaining = Math.max(nextThreshold - total, 0);
    var productTitle = next.querySelector('.promo-gift-bar__product-title').textContent.trim();
    var template = earned.length ? bar.dataset.textNext : bar.dataset.textFirst;

    message.textContent = replaceTokens(template, {
      amount: formatMoney(remaining, bar),
      product: productTitle,
      count: String(earned.length)
    });
    progress.style.width = progressPercent + '%';

    tiers.forEach(function (tier) {
      var status = tier.querySelector('[data-tier-status]');
      if (!status) return;
      if (tier.dataset.tierEarned === 'true') {
        status.textContent = bar.dataset.textEarned;
      } else {
        status.textContent = replaceTokens(bar.dataset.textAt, {
          amount: formatMoney(Number(tier.dataset.tierThreshold), bar)
        });
      }
    });
  }

  function renderBars() {
    getBars().forEach(renderBar);
  }

  function requestJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) throw new Error(json.description || json.message || 'Cart request failed');
        return json;
      });
    });
  }

  function getDesiredGifts(bar) {
    if (!bar || bar.dataset.promoEnabled === 'false' || bar.dataset.promoAutoAddEnabled !== 'true') return [];

    return Array.prototype.slice.call(bar.querySelectorAll('[data-promo-tier][data-tier-earned="true"]')).map(function (tier) {
      return {
        tierKey: String(tier.dataset.tierKey),
        variantId: Number(tier.dataset.tierVariantId)
      };
    }).filter(function (gift) {
      return gift.tierKey && gift.variantId;
    });
  }

  function syncGiftLines() {
    if (syncing) return Promise.resolve();

    var bar = getActiveBar();
    if (!bar) return Promise.resolve();

    syncing = true;
    getBars().forEach(function (item) { item.classList.add('processing'); });

    var desired = getDesiredGifts(bar);
    var matchedTiers = {};
    var hasChanges = false;

    return requestJson(KROWN.settings.routes.cart_url + '.js')
      .then(function (cart) {
        var updates = {};
        var paidItemsToKeep = [];

        cart.items.forEach(function (item) {
          var tierKey = item.properties && item.properties._promo_gift_tier;
          if (!tierKey) return;

          tierKey = String(tierKey);
          var expected = desired.find(function (gift) {
            return gift.tierKey === tierKey && gift.variantId === Number(item.variant_id);
          });

          if (expected && !matchedTiers[tierKey]) {
            matchedTiers[tierKey] = true;
          } else {
            updates[item.key] = 0;
            hasChanges = true;

            // Only one unit belongs to the automatic promotion. Any quantity
            // added by the customer must remain in the cart as a normal item.
            if (item.quantity > 1) {
              paidItemsToKeep.push({
                id: Number(item.variant_id),
                quantity: item.quantity - 1
              });
            }
          }
        });

        var updatePromise = Object.keys(updates).length
          ? requestJson(KROWN.settings.routes.cart_update_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            })
          : Promise.resolve();

        return updatePromise.then(function () {
          var missing = desired.filter(function (gift) { return !matchedTiers[gift.tierKey]; });
          var itemsToAdd = paidItemsToKeep.concat(missing.map(function (gift) {
            return {
              id: gift.variantId,
              quantity: 1,
              properties: { _promo_gift_tier: gift.tierKey }
            };
          }));

          if (!itemsToAdd.length) return;

          hasChanges = true;
          return requestJson(KROWN.settings.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: itemsToAdd
            })
          });
        });
      })
      .then(function () {
        if (hasChanges) return refreshCartAndBar();
      })
      .catch(function (error) {
        console.error('Cumulative gift sync error:', error);
      })
      .finally(function () {
        syncing = false;
        getBars().forEach(function (item) { item.classList.remove('processing'); });
      });
  }

  function replacePromoBar(sectionDocument) {
    var pageBar = document.getElementById('PromoGiftBarPage');
    var drawerBar = document.getElementById('PromoGiftBar');
    var sourceId = pageBar ? 'AjaxPromoGiftBarPage' : 'AjaxPromoGiftBar';
    var source = sectionDocument.getElementById(sourceId);
    var current = pageBar || drawerBar;

    if (source && current) current.outerHTML = source.innerHTML;
  }

  function refreshCartAndBar() {
    return fetch('?section_id=helper-cart')
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var sectionDocument = new DOMParser().parseFromString(text, 'text/html');
        var sourceForm = sectionDocument.getElementById('AjaxCartForm');
        var sourceSubtotal = sectionDocument.getElementById('AjaxCartSubtotal');
        var cartItems = document.getElementById('AjaxCartForm');
        var subtotal = document.getElementById('AjaxCartSubtotal');

        if (sourceForm && cartItems) {
          cartItems.innerHTML = sourceForm.innerHTML;
          if (typeof cartItems.ajaxifyCartItems === 'function') cartItems.ajaxifyCartItems();

          document.querySelectorAll('[data-header-cart-count]').forEach(function (element) {
            element.textContent = cartItems.querySelector('[data-cart-count]').textContent;
          });
          document.querySelectorAll('[data-header-cart-total]').forEach(function (element) {
            element.textContent = cartItems.querySelector('[data-cart-total]').textContent;
          });
        }

        if (sourceSubtotal && subtotal) subtotal.innerHTML = sourceSubtotal.innerHTML;
        replacePromoBar(sectionDocument);
        renderBars();

        var countElement = cartItems && cartItems.querySelector('[data-cart-count]');
        var drawer = document.querySelector('[data-js-site-cart-sidebar]');
        if (drawer && countElement) {
          drawer.classList.toggle('cart-is-empty', (Number(countElement.textContent) || 0) === 0);
          if (typeof drawer.show === 'function') drawer.show();
        }

        if (document.querySelector('cart-recommendations')) {
          document.querySelector('cart-recommendations').innerHTML = '';
          document.querySelector('cart-recommendations').generateRecommendations();
        }
      });
  }

  function refreshBarAndSync() {
    return fetch('?section_id=helper-cart')
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var sectionDocument = new DOMParser().parseFromString(text, 'text/html');
        replacePromoBar(sectionDocument);
        renderBars();
        return syncGiftLines();
      })
      .catch(function (error) {
        console.error('Cumulative gift refresh error:', error);
      });
  }

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      renderBars();
      syncGiftLines();
    }, delay || 0);
  }

  function init() {
    renderBars();
    scheduleSync(0);

    var cartForm = document.getElementById('AjaxCartForm');
    if (cartForm) {
      new MutationObserver(function () {
        if (syncing) return;
        clearTimeout(observerTimer);
        observerTimer = setTimeout(refreshBarAndSync, 350);
      }).observe(cartForm, { childList: true, subtree: true });
    }
  }

  document.addEventListener('cart-updated', function () { scheduleSync(100); });
  window._promoGiftSync = function () { scheduleSync(0); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
